import {yupResolver} from '@hookform/resolvers/yup';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField} from '@mui/material';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import {useForm, useWatch} from 'react-hook-form';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import * as yup from 'yup';

const schema = yup.object().shape({
  value: yupFormSchemas.string('Respuesta'),
});

function ConfirmModal(props) {
  const {isInput, defaultValue = 'Motivo'} = props;

  const [initialValues] = useState({
    value: defaultValue,
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues,
  });

  const {ref: valueRef, ...valueProps} = form.register('value');

  const watchValue = useWatch({
    name: 'value',
    control: form.control,
    defaultValue,
  });

  return ReactDOM.createPortal(
    <Dialog
      open={true}
      onClose={props.onClose}
      maxWidth="xs"
      fullWidth={true}
      sx={{zIndex: (theme) => theme.zIndex.modal + 200}}>
      <DialogTitle>
        <span
          style={{
            fontSize: '1.3rem',
          }}>
          {props.title}
        </span>
      </DialogTitle>

      {props.heightCustomBody && props.renderCustomBody && (
        <Grid style={{height: props.heightCustomBody}}>{props.renderCustomBody}</Grid>
      )}
      {isInput && (
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="value"
            label=""
            type="text"
            fullWidth
            inputRef={valueRef}
            {...valueProps}
            error={Boolean(form.formState.errors.value)}
            helperText={form.formState.errors.value?.message}
          />
        </DialogContent>
      )}

      <DialogActions>
        <Button
          onClick={props.onClose}
          color="primary"
          style={{
            fontSize: '0.9rem',
          }}>
          {props.cancelText}
        </Button>
        <Button
          onClick={(event) => props.onConfirm(event, watchValue)}
          color="primary"
          style={{
            fontSize: '0.9rem',
          }}
          autoFocus={!isInput}>
          {props.okText}
        </Button>
      </DialogActions>
    </Dialog>,
    (document as any).getElementById('modal-root'),
  );
}

export default ConfirmModal;
